__turbopack_context__.v({
  "bulk-input": "BulkInput-module-scss-module__sJw1bW__bulk-input",
  "switch-mode-btn": "BulkInput-module-scss-module__sJw1bW__switch-mode-btn",
  "switch-mode-container": "BulkInput-module-scss-module__sJw1bW__switch-mode-container",
});
